import { render, staticRenderFns } from "./WCO.vue?vue&type=template&id=4cf8ec2f&scoped=true"
import script from "./WCO.vue?vue&type=script&lang=js"
export * from "./WCO.vue?vue&type=script&lang=js"
import style0 from "./WCO.vue?vue&type=style&index=0&id=4cf8ec2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf8ec2f",
  null
  
)

export default component.exports